import styled from 'styled-components';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import { PreviewOutlined, GitHub } from '@mui/icons-material';
import { mobile } from '../../responsive';
import './portfolio.scss';

const Info = styled.div`
   opacity: 0;
   width: 100%;
   height: 100%;
   position: absolute;
   top: 0;
   left: 0;
   background-color: rgba(0, 0, 0, 0.2);
   z-index: 3;
   display: flex;
   justify-content: center;
   align-items: center;
   transition: all 0.5s ease;
   cursor: pointer;
   border-radius: 25px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    color: #fff;
    margin: 20px;
    width: 25%;
    min-height: 100px;
    border-radius: 25px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid rgb(240, 239, 239);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    position: relative;
    &:hover ${Info}{
        opacity: 1;
    }
    ${mobile({
    width: '35%',
    margin: '15px'
  })};
`;

const Title = styled.h3`
  font-size: 1rem;
  position: absolute;
  top: 10px;
`;

const Image = styled.img`
   width: 100%;
   height: 100%;
   object-fit: contain;
   z-index: 1;
   border-radius: 15px;
`;

const Badge = styled.img`
    position: absolute;
    bottom: -15px;
    right: -25px;
    width: 50px;
    height: 50px;
    z-index: 2;
`;

const Icon = styled.div`
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: black;
    margin: 7px;
    transition: all 0.5s ease;
    cursor: pointer;
    &:hover {
        background-color: #${(props) => props.bg};
        transform: scale(1.1);
    }
    a {
        text-decoration: none;
        color: black;
    }

    ${mobile({
    maxWidth: '30px',
    maxHeight: '30px',
  })};

`;

const CredentialButton = styled.a`
    font-size: 1.1rem;
    text-decoration: none;
    color: #3a3b3c;
    background-color: #fff;
    border: 1px solid #3a3b3c;
    border-radius: 25px;
    padding: 5px 10px;
    margin: 5px;
    transition: all 0.5s ease;
    cursor: pointer;
    &:hover {
      border: 1px solid #333;
      color: #333;
      transform: scale(1.1);
    }

    ${mobile({
    fontSize: '0.9rem',
    padding: '3px 6px',
  })};
`;

const PortfolioCard = (props) => {
  const { item } = props;
  const {
    id,
    img,
    badgeImg,
    fullStack,
    title,
    credentialUrl, sourceUrl, liveUrl,
  } = item;

  return (
    <Container
      as={motion.div}
      initial={{
        opacity: 0,
        translateY: 70,
      }}
      animate={{
        opacity: 1.2,
        translateY: 0,
      }}
      transition={{
        duration: 0.4,
        delay: id * 0.35,
      }}
    >
      <Title>{title}</Title>
      <Image src={img} alt="project image" />
      {fullStack
            && (
            <Badge
              src={badgeImg}
              alt=""
            />
            )}
      <Info>
        {
        credentialUrl ? (
          <CredentialButton
            href={credentialUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            See credential
          </CredentialButton>
        ) : (
          <>
            <Icon bg="e9f5f5">
              <a
                href={liveUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <PreviewOutlined />
              </a>
            </Icon>
            <Icon bg="d86a77">
              <a
                href={sourceUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <GitHub />
              </a>
            </Icon>
          </>
        )
        }

      </Info>
    </Container>
  );
};

export default PortfolioCard;

PortfolioCard.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired,
};
